export enum QUERY_KEYS {
  getAdminCities = 'get-admin-cities',
  getClubs = 'get-admin-clubs',
  getAdminCountries = 'get-admin-countries',
  getCountries = 'get-countries',
  getMagicSearch = 'get-admin-magic-search',
}
